import { render, staticRenderFns } from "./cv-code-snippet-skeleton.vue?vue&type=template&id=6271fae8&"
import script from "./cv-code-snippet-skeleton.vue?vue&type=script&lang=js&"
export * from "./cv-code-snippet-skeleton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports